import { navigate } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { ConfirmationDialog } from '@components/ConfirmationDialog';
import Icon from '@components/Icon/Icon';

import { useCurationMode } from '@contexts/CurationModeContext';

import { useAutoCuration } from '@hooks/useAutoCuration';

import { useUpdateDiscernResultStatus } from 'generated/discern.generated';
import { DiscernResultStatus } from 'generated/types';

const messages = defineMessages({
  deleteConfirm: {
    id: 'drilldownHeader.deleteConfirm',
    defaultMessage: 'Are you sure you want to delete this record?',
  },
  permanent: {
    id: 'drilldownHeader.permanent',
    defaultMessage:
      'This cannot be undone. All tasks, associations, and references to another resource will be deleted as well.',
  },
  deletePhrase: {
    id: 'confirmation.deletePhrase',
    defaultMessage: 'DELETE',
  },
  deleteConfirmation: {
    id: 'GLOBAL.deleteConfirmation',
    defaultMessage: 'To confirm deletion, type {phrase} in the field.',
  },
});

export default function AutoCurationDrilldownDeleteButton() {
  const { formatMessage } = useIntl();
  const { curationMode } = useCurationMode();
  const {
    state,

    removeManualResource,
  } = useAutoCuration();
  const { currentRecord } = state;

  const [updateResultStatus] = useUpdateDiscernResultStatus();

  // Don't show delete button if no record exists
  if (!currentRecord) {
    return null;
  }

  const handleDelete = async () => {
    if (curationMode && currentRecord.bboxId) {
      const isManual = currentRecord.bboxId.startsWith('manual');

      if (isManual) {
        removeManualResource(currentRecord.bboxId);
        navigate(
          `${window.location.pathname}?result_id=${currentRecord.nextId}`,
          {
            replace: true,
          }
        );
        return;
      }

      try {
        await updateResultStatus({
          variables: {
            input: {
              discern_result_id: currentRecord.discern_result_id!,
              status: DiscernResultStatus.Delete,
            },
          },
        });
        if (currentRecord.discern_result_id === currentRecord.nextId) {
          navigate(`${window.location.pathname.split('/curate')[0]}`);
        } else {
          navigate(
            `${window.location.pathname}?result_id=${currentRecord.nextId}`,
            {
              replace: true,
            }
          );
        }
      } catch {
        // silently ignore errors
      }
    }
  };
  return (
    <ConfirmationDialog
      challenge={{
        description: formatMessage(messages.deleteConfirmation, {
          phrase: formatMessage(messages.deletePhrase),
        }),
        phrase: formatMessage(messages.deletePhrase),
      }}
      content={formatMessage(messages.permanent)}
      onConfirm={handleDelete}
      title={formatMessage(messages.deleteConfirm)}
    >
      {({ handleOpen }) => (
        <Icon
          clickable
          color="common.white"
          name="trash"
          onClick={handleOpen}
          type="fas"
        />
      )}
    </ConfirmationDialog>
  );
}
